<template>
	<v-card>
		<v-card-title>
			<h2>Naprawienie błędów systemu</h2>
			<v-spacer></v-spacer>
		</v-card-title>

		<v-card-text>
			<div>
				<v-alert :value="true" color="info">
					Przy każdym zapisie projektu jego sprawozdanie jest przebudowywane.
					Poprzednie sprawozdanie jest usuwane, a na jego miejscu powstaje nowe.
					Potrzeba przebudowy sprawozdania wynika z tego, że zależy ono od wprowadzonych w projekcie danych.
					Niepowodzenie zapisu projektu przez oferenta w niektórych przypadkach mogło skutkować usunięciem poprzedniego sprawozdania i niewygenerowaniem nowego.
					Powoduje to niespójność w systemie, którą należy usunąć, tworząc ręcznie nowe, puste sprawozdanie projektu.
					Aby utworzyć sprawozdanie dla projektu, należy kliknąć przycisk "Wygeneruj sprawozdanie projektu" oraz wybrać projekt.
				</v-alert>
			</div>
		</v-card-text>

		<v-dialog v-model="dialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="mt-2 ml-5 mb-5">Wygeneruj sprawozdanie projektu</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline">Wygeneruj sprawozdanie projektu</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-autocomplete
									label="Nazwa projektu"
									:items="projects"
									item-text="title"
									item-value="id"
									aria-label="Project name"
									for="system-fix-view-projects"
									id="system-fix-view-projects"
									v-model="selectedProjectId"
								></v-autocomplete>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="createProjectEmptyReport()" v-if="selectedProjectId">Wygeneruj</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-card-text>
			<div>
				<v-alert :value="true" color="info">
					Poniższy przycisk służy jako tymczasowe rozwiązanie błędu ze znikaniem kosztów administracyjnych.
					Należy go użyć w przypadku, gdy do bieżącej wersji sprawozdania końcowego projektu chcemy załadować koszty
					administracyjne projektu.
				</v-alert>
			</div>
		</v-card-text>

		<v-dialog v-model="administrativeCostsDialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="mt-2 ml-5 mb-5">Załaduj koszty administracyjne projektu</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline">Załaduj koszty administracyjne projektu</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-autocomplete
									label="Nazwa projektu"
									:items="allProjects"
									item-text="title"
									item-value="id"
									aria-label="Project name"
									for="administrative-costs-project-fix"
									id="administrative-costs-project-fix"
									v-model="selectedProjectId"
								></v-autocomplete>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="loadAdministrativeCosts()" v-if="selectedProjectId">Załaduj</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-card-text>
			<div>
				<v-alert :value="true" color="info">
					Poniższy przycisk służy jako tymczasowe rozwiązanie błędu ze znikaniem kosztów programowych.
					Należy go użyć w przypadku, gdy do bieżącej wersji sprawozdania końcowego projektu chcemy załadować koszty
					programowe projektu.
				</v-alert>
			</div>
		</v-card-text>

		<v-dialog v-model="actionCostsDialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="mt-2 ml-5 mb-5">Załaduj koszty programowe projektu</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline">Załaduj koszty programowe projektu</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-autocomplete
									label="Nazwa projektu"
									:items="allProjects"
									item-text="title"
									item-value="id"
									aria-label="Project name"
									for="action-costs-project-fix"
									id="action-costs-project-fix"
									v-model="selectedProjectId"
								></v-autocomplete>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="loadActionCosts()" v-if="selectedProjectId">Załaduj</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-card-text>
			<div>
				<v-alert :value="true" color="info">
					Poniższy przycisk służy do usunięcia ostatniej wersji projektu. Umożliwia samodzielne usuwanie wersji
					przez Głównego Administratora zamiast wykonywania zapytania bezpośrednio na bazie danych.
					Wymagane jest wskazanie projektu, którego ostatnia wersja powinna zostać usunięta.
				</v-alert>
			</div>
		</v-card-text>

		<v-dialog v-model="projectVersionRemovalDialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="mt-2 ml-5 mb-5">Usuń ostatnią wersję projektu</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline">Usuń ostatnią wersję projektu</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-alert :value="true" color="error">
									Operacja usunięcia jest nieodwracalna! Wszystkie dane z ostatniej wersji zostaną usunięte!
								</v-alert>
							</v-flex>
							<v-flex xs12 sm6 md12>
								<v-autocomplete
									label="Kod projektu"
									:items="allProjects"
									item-text="projectCode"
									item-value="id"
									aria-label="Project code"
									for="project-removal-code"
									id="project-removal-code"
									v-model="selectedProjectId"
								></v-autocomplete>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<v-expand-transition>
								<div v-if="selectedProjectId" style="overflow-wrap: break-word; inline-size: 420px">
									<b class="mr-1">Tytuł:</b> {{ selectedProject.title }}
								</div>
							</v-expand-transition>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="removeLastProjectVersion()" v-if="selectedProjectId">Usuń</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-card-text>
			<div>
				<v-alert :value="true" color="info">
					Poniższy przycisk służy do ręcznej korekty danych oferenta zawartych w wysłanej ofercie.
					Umożliwia edycję nazwy oraz adresu siedziby autorów ostatniej wersji oferty.
					Dane oferenta są zmieniane dla każdej wersji tej oferty.
				</v-alert>
			</div>
		</v-card-text>

		<v-dialog v-model="bidderOfferOriginalDataDialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="mt-2 ml-5 mb-5">Edytuj dane oferenta w ofercie</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline">Edytuj dane oferenta w ofercie</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex>
								<v-alert :value="true" color="error">
									Operacja jest nieodwracalna! Obecna nazwa oferenta oraz adres siedziby zostaną utracone!
								</v-alert>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<v-flex>
								<v-autocomplete
									label="Kod oferty"
									:items="allOffers"
									item-text="offerCode"
									item-value="id"
									aria-label="Offer code"
									for="offer-code"
									id="offer-code"
									v-model="selectedOfferId"
								></v-autocomplete>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<v-expand-transition>
								<div v-if="selectedOfferId" style="overflow-wrap: break-word; inline-size: 420px">
									<b class="mr-1">Tytuł:</b> {{ selectedOffer.title }}
									<v-autocomplete
										class="mt-3"
										label="Oferent"
										:items="selectedOfferBidders"
										item-text="polishName"
										item-value="id"
										aria-label="Nazwa oferenta"
										for="bidder-name"
										id="bidder-name"
										v-model="selectedBidderId"
									></v-autocomplete>
									<v-expand-transition>
										<SystemFixBidderFormView
											ref="systemFixBidderForm"
											v-if="selectedBidderData"
											:selectedBidderData="selectedBidderData"/>
									</v-expand-transition>
								</div>
							</v-expand-transition>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="editBidderOfferOriginalData()"
						v-if="selectedOfferId && selectedBidderId">Edytuj</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>


		<v-card-text>
			<div>
				<v-alert :value="true" color="info">
					Poniższy przycisk służy jako rozwiązanie błędu związanego z błędnie 
					zapisanymi kosztami programowymi we wszystkich już utworzonych projektach.
				</v-alert>
			</div>
		</v-card-text>

		<v-dialog v-model="repairAllProjectsActionCostsDialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="mt-2 ml-5 mb-5">Załaduj koszty programowe wszystkich projektów</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline">Załaduj koszty programowe wszystkich projektów</span>
				</v-card-title>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="repairAllProjectsActionCosts()">Załaduj</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-card-text>
			<div>
				<v-alert :value="true" color="info">
					Poniższy przycisk służy jako rozwiązanie błędu związanego z niewygenerowanymi opisami działań programowych w projekcie.
				</v-alert>
			</div>
		</v-card-text>

		<v-dialog v-model="projectActionsDescriptionsDialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="mt-2 ml-5 mb-5">Załaduj opisy działań programowych projektu</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline">Załaduj opisy działań programowych projektu</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-autocomplete
									label="Nazwa projektu"
									:items="allProjects"
									item-text="title"
									item-value="id"
									aria-label="Project name"
									for="actions-descriptions-fix"
									id="actions-descriptions-fix"
									v-model="selectedProjectId"
								></v-autocomplete>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="loadActionsDescriptions()" v-if="selectedProjectId">Załaduj</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>


	</v-card>
</template>

<script>
	import {Bidder} from "@/api/generated/Bidder";
	import {FinalReport} from "@/api/generated/FinalReport";
	import {Offer} from "@/api/generated/Offer";
	import {Project} from "@/api/generated/Project";
  import SystemFixBidderFormView from "@/view/logged/system/SystemFixBidderFormView";

	export default {
		name: "SystemFixView",
    components: {SystemFixBidderFormView},

    data() {
			return {
				dialog: false,
        administrativeCostsDialog: false,
        actionCostsDialog: false,
        projectVersionRemovalDialog: false,
        bidderOfferOriginalDataDialog: false,
				projects: [],
        allOffers: [],
        allProjects: [],
        selectedOfferBidders: [],
        selectedOfferId: null,
        selectedBidderId: null,
				selectedProjectId: null,
        selectedBidderData: null,
		repairAllProjectsActionCostsDialog: false,
		projectActionsDescriptionsDialog: false
			};
		},

		created() {
			this.refresh();
		},

    watch: {
      selectedOfferId(offerId) {
        this.selectedBidderId = null;
        if (!offerId) {
          return;
        }

        Bidder.getOfferBiddersOriginalData(this, offerId, successResponse => {
          this.selectedOfferBidders = successResponse;
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się pobrać listy oferentów", errorResponse);
        });
      },

      selectedBidderId(bidderId) {
        this.selectedBidderData = this.selectedOfferBidders.find(bidder => bidder.id === bidderId);
      }
    },

    computed: {
      selectedOffer() {
        return this.allOffers.find(o => o.id === this.selectedOfferId);
      },

      selectedProject() {
        return this.allProjects.find(p => p.id === this.selectedProjectId);
      }
    },

		methods: {
      refresh() {
        Project.getProjectsWithoutReports(this, successResponse => {
          this.projects = successResponse;
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się pobrać listy projektów", errorResponse);
        });

        Project.getAllProjectsNamesAndCodes(this, successResponse => {
          this.allProjects = successResponse;
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się pobrać listy wszystkich projektów", errorResponse);
        });

        Offer.getAllOffersNamesAndCodes(this, successResponse => {
          this.allOffers = successResponse;
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się pobrać listy wszystkich ofert", errorResponse);
        });
      },

			createProjectEmptyReport() {
				FinalReport.postEmptyReport(this, this.selectedProjectId, successResponse => {
					this.$messagesBus.$emit("success", "Sprawozdanie zostało pomyślnie wygenerowane", successResponse);
					this.refresh();
					this.dialog = false;
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się wygenerować sprawozdania", errorResponse);
				});
			},

      loadAdministrativeCosts() {
        FinalReport.putLoadAdministrativeCostsFromProject(this, this.selectedProjectId, successResponse => {
          this.$messagesBus.$emit("success", "Koszty zostały pomyślnie załadowane", successResponse);
          this.close();
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować kosztów", errorResponse);
        });
      },

      loadActionCosts() {
        FinalReport.putLoadActionCostsFromProject(this, this.selectedProjectId, successResponse => {
          this.$messagesBus.$emit("success", "Koszty zostały pomyślnie załadowane", successResponse);
          this.close();
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować kosztów", errorResponse);
        });
      },

      repairAllProjectsActionCosts() {
		FinalReport.postRepairActionCostsFromAllProjects(this, successResponse => {
          this.$messagesBus.$emit("success", "Koszty zostały pomyślnie załadowane", successResponse);
          this.close();
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować kosztów", errorResponse);
        });
      },
    
      removeLastProjectVersion() {
        Project.deleteLastVersion(this, this.selectedProjectId, successResponse => {
          this.$messagesBus.$emit("success", "Ostatnia wersja została pomyślnie usunięta", successResponse);
          this.close();
        }, errorResponse => {
          let message = "Nie udało się usunąć ostatniej wersji";
          if (errorResponse.message === "Projekt ma tylko jedną wersję") {
            message = message.concat(". ").concat(errorResponse.message);
          }
          this.$messagesBus.$emit("error", message, errorResponse);
        });
      },

      editBidderOfferOriginalData() {
        this.$refs.systemFixBidderForm.$validator.validateAll().then((result) => {
          if (!result) {
            return;
          }

          Bidder.putOfferBidderOriginalData(this, this.selectedOfferId, this.selectedBidderId, this.$refs.systemFixBidderForm.bidder, successResponse => {
            this.$messagesBus.$emit("success", "Dane oferenta zostały pomyślnie zapisane", successResponse);
            this.close();
          }, errorResponse => {
            this.$messagesBus.$emit("error", "Nie udało się zapisać danych oferenta", errorResponse);
          });
        });
      },

	  loadActionsDescriptions(){
        Project.putLoadActionsDescritopns(this, this.selectedProjectId, successResponse => {
          this.$messagesBus.$emit("success", "Opisy działań programowych zostały pomyślnie załadowane", successResponse);
          this.close();
        }, errorResponse => {
			if(errorResponse && errorResponse.message){
				this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
			} else{
				this.$messagesBus.$emit("error", "Nie udało się załadować opisów działań programowych", errorResponse);
			}
        });
      },

			close() {
        this.selectedOfferId = null;
        this.selectedBidderId = null;
				this.selectedProjectId = null;
        this.selectedBidderData = null;
				this.dialog = false;
        this.administrativeCostsDialog = false;
        this.actionCostsDialog = false;
        this.projectVersionRemovalDialog = false;
        this.bidderOfferOriginalDataDialog = false;
		this.repairAllProjectsActionCostsDialog = false;
		this.projectActionsDescriptionsDialog = false;
			}
		}
	};
</script>

<style scoped>

</style>
